import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import "./Leads.css";
import api from "../../seller-apis/api";
import Popup from "../common/Popup";
import UnlockPopupSuccess from "./popup/UnlockPopupSuccess";
import { Actions } from "../../Actions/Actions";
import StatusUpdatePopup from "./popup/statusUpdatePopup";
import PaginationNew from "../common/Pagination";
import SubscriptionView from "./SubscriptionView";
import WalletPopup from "../WalletTransaction/walletPopup";
var filterData = {
  pageSize: 1,
  size: 12,
  vendorFilter:{
    'status':'LOCKED'
  }
};
var filterDataUnocked = {
  pageSize: 1,
  size: 1,
  vendorFilter:{
    'status':{'$ne':'LOCKED'}
  }
};
const LockedLeads = (props) => {
  const dispatch = useDispatch();
  const [leads, setLeads] = useState([]);
  const [showUnlock, setShowUnlock] = useState(false);
  const [showWalletPopup, setShowWalletPopup] = useState(false);
  const [showUnlockSuccess, setShowUnlockSuccess] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [statusToBeUpdated, setStatusToBeUpdated] = useState("");
  const [sku, setSku] = useState("");
  const [statusObject, setStatusObject] = useState({});
  const [isDetailPopupVis, setisDetailPopupVis] = useState(false);
  const [productDetail, setproductDetail] = useState([]);
  const [unlockedLeads, setUnLockedLeads] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalrecords, setTotalRecords] = useState();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const walletAmt=useSelector(state=>state.ActionReducer.WalletAmount);
console.log(walletAmt)
  function getLeads(data = filterData) {

    api.customerLeads.getLeads(data).then((res) => {
    
      setTotalRecords(res.data.totalRecords);
      Actions.leadCount(dispatch,res.data.totalRecords);
      let tempLockedArray=[];
        let otherLeads=[];

        res.data.records.forEach(element => {
          if(element?.vendorDetails?.vendors[0]?.status != "LOCKED"){
            otherLeads.push(element);
          }
          else{
            tempLockedArray.push(element);
          }
        });

        setUnLockedLeads(otherLeads);
      setLeads(tempLockedArray);
    });
    api.customerLeads.getLeads(filterDataUnocked).then((res) => {
    
        setUnLockedLeads(res.data.totalRecords);
    });
  }
  useEffect(() => {
    getLeads(filterData);
  }, []);
  
  const handleUnlockClose = () => {
    setShowUnlock(false);
  };

  function paginate(data) {
    let param = {
      vendorFilter:{...filterData.vendorFilter},
      pageNo: data.number,
      size: 12,
    };
    getLeads(param);
    setSelectedPage(data.number);
  }

  const handleUnlockSuccessClose = () => {
    setShowUnlockSuccess(false);
  };
  const updateSatus = (leadId, status) => {
    let param = {
      _id: leadId,
      status: status,
    };

    api.customerLeads
      .updateStatus(param)
      .then((data) => {
        status === "OPEN" && setShowUnlockSuccess(true);
        setShowUnlock(false);
        getAmount();
        // getLeads();
        if(data.message=="success")
        setTotalRecords(totalrecords-1);
        Actions.leadCount(dispatch,totalrecords-1);
        if (leads[selectedIndex]?.vendorDetails?.vendors[0]) {
          leads[selectedIndex].vendorDetails.vendors[0].status = status;
      }
        setLeads([...leads])
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getAmount = () => {
    api.customerLeads.getWalletBallence().then((data) => {
      // setCurrWalletBal(data?.data?.record?.wallet?.currentBal);
      Actions.upadteWalletAmount(
        dispatch,
        data?.data?.record?.wallet || []
      );
    });
  };
  const productDetails = (data) => {
    setisDetailPopupVis(true);
    setproductDetail([data]);
  };
  const setpopupVisibilityDetail = () => {
    setisDetailPopupVis(false);
  };
  const applyFilter=()=>{
    filterData['filter']={
      "productDetails.SKU":sku
    }
    getLeads(filterData);
  }
  return (
    <div className="row px-4">
      <div className="row mb-4 py-2 border-bottom-1">
        <div className="col-md-4"></div>
      <div className="col-md-4 text-center dis-flex">
        <input type="text" value={sku} onChange={(e) => setSku(e.target.value)} className="form-control" placeholder="SKU" />
        <button className="apply-btn" onClick={() => applyFilter()}>Search</button>
      </div>
      <div className="col-md-4 text-right dis-flex">
        {/* <SubscriptionView /> */}
        <NavLink to="/customer-leads/details">GoTo Purchase Leads</NavLink>
      </div>
      </div>
      <div className="px-4 row">
      {leads.length > 0 &&
        leads.map((item, index) => {
          return (
            <>
              {item?.vendorDetails?.vendors[0]?.status == "LOCKED" && (
                <div className="col-md-3 mb-2">
                  <div class="card">
                    <div className="card-body leads-details">
                      <div className="mb-2 product-name">
                        {item?.product?.productName} <br />{" "}
                        <div className="question-sku-but">
                          <div
                            className="prod-sku w-100 cursor-pointer"
                            onClick={() => productDetails(item?.product)}
                          >
                            <a href="#popupDetail" className="prod-sku">
                              SKU : {item?.product.SKU}
                            </a>
                          </div>
                        </div>
                        <div className="question-sku-but">
                          {/* <div
                            className="prod-sku w-100 cursor-pointer"
                          >
                            <div className="">
                          <div className="fs-11">Expected price : <span style={{color:"#000"}}>&#8377; {item?.product?.expectedPrice}</span></div>
                          <div className="fs-11">Expected Delivery : <span style={{color:"#000"}}>{item.time}</span></div>
                        </div>
                          </div> */}
                        </div>
                      </div>
                      <div className="details">
                      
                        <div className="mb-2 dis-flex">
                          <i class="fa fa-user" aria-hidden="true"></i>
                          {item.name}
                        </div>
                        {/* <div className="mb-2 dis-flex">
                          <i class="fa fa-map-marker" aria-hidden="true"></i>{" "}
                          {item.state}, {item.pincode}
                        </div> */}
                        <div className="mb-2 dis-flex">
                          <i class="fa fa-phone" aria-hidden="true"></i>{" "}
                          {item?.vendorDetails?.vendors[0]?.status !=
                          "LOCKED" ? (
                            item.phone
                          ) : (
                            <div className="blur-phone">0000000000</div>
                          )}
                        </div>
                        <div className="mb-2 dis-flex"> {item.remark}</div>
                      </div>
                      <div className="mb-2 mt-4 dis-flex lead-status-button justify-content-center">
                      {(unlockedLeads<5 || walletAmt?.freeBal>0)?<button
                          className="apply-btn unlock-button"
                          onClick={() => {
                            setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                            setStatusToBeUpdated("OPEN");
                            setSelectedPrice(item?.leadPrice);
                            setSelectedLeadId(item._id);
                            setShowUnlock(true);
                            setSelectedIndex(index)
                          } }
                        >
                          Unlock
                        </button>:
                        <button
                          className="apply-btn unlock-button"
                          onClick={() => {
                            walletAmt?.currentBal>0&&setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                            walletAmt?.currentBal>0&&setStatusToBeUpdated("OPEN");
                            walletAmt?.currentBal>0&&setSelectedPrice(item?.leadPrice);
                            walletAmt?.currentBal>0&&setSelectedLeadId(item._id);
                            walletAmt?.currentBal>0&&setShowUnlock(true);
                            walletAmt?.currentBal<=0&&setShowWalletPopup(true);
                            setSelectedIndex(index)
                          } }
                        >
                          Unlock
                        </button>}
                        {/* <button
                          className="apply-btn unlock-button red-button"
                          onClick={() => {
                            setStatusObject({"title":"","subTitle":"Are you sure you want to delete this lead?"});
                            setStatusToBeUpdated("NOT_RELEVENT");
                            setSelectedPrice(item?.leadPrice);
                            setSelectedLeadId(item._id);
                            setShowUnlock(true);
                          }}
                        >
                          Not Relevent
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          );
        })}
        {leads.length == 0 &&
          <div className="text-center py-5">
            No new leads available
          </div>
        }
        <PaginationNew
          number={totalrecords}
          paginate={paginate}
          activ={selectedPage}
          comp={"details"}
        />
        </div>
      <StatusUpdatePopup
        show={showUnlock}
        handleUnlockClose={handleUnlockClose}
        updateSatus={updateSatus}
        status={statusToBeUpdated}
        statusObject={statusObject}
        leadId={selectedLeadId}
        selectedPrice={selectedPrice}
      />
      <UnlockPopupSuccess
        show={showUnlockSuccess}
        handleUnlockClose={handleUnlockSuccessClose}
      />
      <WalletPopup show={showWalletPopup} handleClose={()=>setShowWalletPopup(false)} />
      {isDetailPopupVis && (
        <div id="popupDetail" className="overlay" style={{ display: "block" }}>
          <Popup
            from="newOrder"
            description={productDetail[0].desc}
            sdescription={productDetail[0].sDesc}
            descriptionNew={productDetail[0].descriptionNew}
            specificationNew={productDetail[0].specificationNew}
            name={productDetail[0].productName}
            // price={detailPPrice}
            SKU={productDetail[0].SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0].image}
            videos={productDetail[0].video}
          />
        </div>
      )}
    </div>
  );
};

export default LockedLeads;
